import React, { useState, useEffect, useRef } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import OfferDetailsModal from "./VendorOffers/OfferDetailsModal";
import { useSelector } from "react-redux";
import PayModal from "../../../components/Header/modals/PayModal";
import NegotiateModal from "./VendorOffers/NegotiateModal";
import { toast } from "react-toastify";
import { FaEllipsisH } from "react-icons/fa";
import "./messages.css";
const MenuItems = ({ isMenuOpen, setIsMenuOpen }) => {
  const [offerModalOpen, setOfferModalOpen] = useState(false);
  const [negotiate, setNegotiate] = useState(false);
  const [accept, setAccept] = useState(false);
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  // const logUser = localStorage.getItem("USER_ROLE");
  const logUser = user?.Role;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [viewNegoHistory, setViewNegoHistory] = useState(false);
  const { selectedConvo } = useSelector((state) => state.messages);
  const menuRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (!menuRef.current?.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, []);

  // const ViewOffer = (event, msg) => {
  //   event.stopPropagation();
  //   setOfferModalOpen(true);
  //   setIsMenuOpen(false);
  // };
  const closeOffertModal = (e) => {
    setNegotiate(false);
    setOfferModalOpen(false);
  };

  const handleClick = () => {
    setViewNegoHistory(true);
    setIsMenuOpen(false);
  };

  return (
    <div>
      {/* <Dropdown
        isOpen={isMenuOpen}
        toggle={() => setIsMenuOpen(!isMenuOpen)}
        direction="down"
        flip
        className="chat-dropdown"
      >
        <DropdownToggle
          tag="span"
          style={{ cursor: "pointer" }}
          className="menu-icon"
        >
          <FaEllipsisH />
        </DropdownToggle>
        <DropdownMenu
          end
          style={{
            borderRadius: "4px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
            marginTop: "8px",
            zIndex: 1000,
            width: "250px",
            padding: "10px",
          }}
          className="chat-dropdown-menu"
        >
          <DropdownItem
            onClick={() => setIsMenuOpen(false)}
            disabled
            className="mb-2"
          >
            Block Other Party Messages
          </DropdownItem>
          {user.RoleId !== 1 && (
            <DropdownItem className="my-1">
              {logUser === "customer" &&
                selectedConvo?.providerPhone !== "0" && (
                  <small>{selectedConvo?.providerPhone}</small>
                )}
              {logUser === "provider" &&
                selectedConvo?.customerPhone &&
                selectedConvo?.customerPhone !== "0" && (
                  <div className="d-flex flex-column">
                    <small>
                      Primary Number:
                      <strong>
                        {selectedConvo?.customerPhone?.split(",")[0]}
                      </strong>
                    </small>
                    <small>
                      Family Number 1:
                      <strong>
                        {selectedConvo?.customerPhone.split(",")[1]}
                      </strong>
                    </small>
                    {selectedConvo?.customerPhone.split(",")[2] && (
                      <small>
                        Family Number 2:
                        <strong>
                          {selectedConvo?.customerPhone.split(",")[2]}{" "}
                        </strong>
                      </small>
                    )}
                  </div>
                )}
              {(logUser !== "customer" ||
                selectedConvo?.providerPhone === "0") &&
                (logUser !== "provider" ||
                  selectedConvo?.customerPhone === "0") && (
                  <div
                    className="text-nowrap mb-1"
                    onClick={() => {
                      setIsModalOpen(true);
                      setIsMenuOpen(false);
                    }}
                    style={{
                      cursor: "pointer",
                      color: "black",
                    }}
                  >
                    Request Phone Number
                  </div>
                )}
            </DropdownItem>
          )}
          <DropdownItem
            style={{ marginTop: "0px" }}
            onClick={handleClick}
            disabled={
              (selectedConvo?.messageStatus === 6 ||
                selectedConvo?.messageStatus === 7) &&
              selectedConvo?.postType === 3
                ? false
                : true
            }
          >
            Negotiation History
          </DropdownItem>
        </DropdownMenu>
      </Dropdown> */}
      <div className="chatmenu-dropdown-container" ref={menuRef}>
        <span
          className="menu-icon"
          onMouseDown={(e) => {
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            setIsMenuOpen((prev) => !prev);
          }}
          style={{ cursor: "pointer" }}
        >
          <FaEllipsisH />
        </span>

        {isMenuOpen && (
          <div className="chatmenu-dropdown-menu">
            <div className="menu-dropdown-item disabled mb-2">
              Block Other Party Messages
            </div>
            {user.RoleId !== 1 && (
              <div className="menu-dropdown-item my-1">
                {logUser === "customer" &&
                  selectedConvo?.providerPhone !== "0" && (
                    <small>{selectedConvo?.providerPhone}</small>
                  )}
                {logUser === "provider" &&
                  selectedConvo?.customerPhone &&
                  selectedConvo?.customerPhone !== "0" && (
                    <div className="d-flex flex-column">
                      <small>
                        Primary Number:
                        <strong>
                          {selectedConvo?.customerPhone?.split(",")[0]}
                        </strong>
                      </small>
                      <small>
                        Family Number 1:
                        <strong>
                          {selectedConvo?.customerPhone.split(",")[1]}
                        </strong>
                      </small>
                      {selectedConvo?.customerPhone.split(",")[2] && (
                        <small>
                          Family Number 2:
                          <strong>
                            {selectedConvo?.customerPhone.split(",")[2]}
                          </strong>
                        </small>
                      )}
                    </div>
                  )}

                {(logUser !== "customer" ||
                  selectedConvo?.providerPhone === "0") &&
                  (logUser !== "provider" ||
                    selectedConvo?.customerPhone === "0") && (
                    <div
                      className="text-nowrap mb-1 clickable"
                      onClick={() => {
                        setIsModalOpen(true);
                        setIsMenuOpen(false);
                      }}
                    >
                      Request Phone Number
                    </div>
                  )}
              </div>
            )}

            <div
              className={`menu-dropdown-item ${
                (selectedConvo?.messageStatus === 6 ||
                  selectedConvo?.messageStatus === 7) &&
                selectedConvo?.postType === 3
                  ? "clickable"
                  : "disabled"
              }`}
              onClick={() => {
                const enabled =
                  (selectedConvo?.messageStatus === 6 ||
                    selectedConvo?.messageStatus === 7) &&
                  selectedConvo?.postType === 3;
                if (!enabled) return;
                handleClick();
                setIsMenuOpen(false);
              }}
            >
              Negotiation History
            </div>
          </div>
        )}
      </div>
      {offerModalOpen && (
        <OfferDetailsModal
          isOpen={offerModalOpen}
          closeModal={(e) => closeOffertModal(e)}
          negotiate={negotiate}
          setNegotiate={setNegotiate}
          accept={accept}
          setAccept={setAccept}
          msg={selectedConvo}
          fetchData={() => console.log("reload")}
        />
      )}
      {isModalOpen && (
        <PayModal
          isModalOpen={isModalOpen}
          handleToggleModal={() => {
            setIsModalOpen(false);
          }}
          selectedMsg={selectedConvo}
        />
      )}
      {viewNegoHistory && (
        <NegotiateModal
          isOpen={viewNegoHistory}
          closeModal={() => setViewNegoHistory(false)}
        />
      )}
    </div>
  );
};

export default MenuItems;
